export default __webpack_public_path__ + "static/media/sprint-invitation.42b2e764.svg";